import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { Icon } from '@iconify/react'

const tintBackground = hex => {
  if (!hex || typeof hex !== 'string') return 'transparent'
  const normalized = hex.startsWith('#') ? hex.slice(1) : hex
  if (normalized.length !== 6) return 'transparent'
  const r = parseInt(normalized.slice(0, 2), 16)
  const g = parseInt(normalized.slice(2, 4), 16)
  const b = parseInt(normalized.slice(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, 0.14)`
}

const TagChips = ({ tags }) => {
  if (!tags || tags.length === 0) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '6px',
        alignItems: 'center',
      }}
    >
      {tags.map(tag => (
        <Box
          key={tag.id}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '4px 10px',
            borderRadius: '999px',
            backgroundColor: tintBackground(tag.color),
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              backgroundColor: tag.color,
              display: 'inline-block',
            }}
          />
          <Typography
            component="span"
            sx={{
              fontSize: '11px',
              fontWeight: 700,
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
              color: tag.color,
              lineHeight: 1,
            }}
          >
            {tag.name}
          </Typography>
          {tag.isPublic && (
            <Icon
              icon="mdi:web"
              width={11}
              height={11}
              style={{ color: tag.color }}
            />
          )}
        </Box>
      ))}
    </Box>
  )
}

export default TagChips
